import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import CyberLoader from '../common/CyberLoader';
import ParticleBackground from '../common/ParticleBackground';
import './Dashboard.css';

export default function Dashboard({ onBack }) {
  const [stats, setStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true);
  
  const [activeTab, setActiveTab] = useState('global');

  const username = localStorage.getItem('vault_username');

  useEffect(() => {
    const fetchStats = async () => {
      const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
      const token = localStorage.getItem('vault_jwt');
      try {
        const resp = await fetch(`${baseUrl}/api/stats`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (resp.ok) {
          setStats(await resp.json());
        }
      } catch (e) {}
      setLoadingStats(false);
    };

    fetchStats();
  }, []);

  const logout = () => {
    localStorage.removeItem('vault_jwt');
    localStorage.removeItem('vault_username');
    window.location.reload();
  };

  const renderStats = () => {
    if (!stats) return <div className="dash-error">Unable to load stats.</div>;

    if (activeTab === 'global') {
      return (
        <motion.div 
          className="stats-grid"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          key="global"
        >
          <div className="stat-box wide">
            <span className="stat-label">Total Matches Played</span>
            <span className="stat-value">{stats.global_total_matches || 0}</span>
          </div>
          <div className="stat-box won">
            <span className="stat-label">Total Won</span>
            <span className="stat-value">{stats.global_matches_won || 0}</span>
          </div>
          <div className="stat-box lost">
            <span className="stat-label">Total Lost</span>
            <span className="stat-value">{stats.global_matches_lost || 0}</span>
          </div>
        </motion.div>
      );
    }

    const modeData = stats.modes && stats.modes[activeTab];
    if (!modeData) {
      return (
        <motion.div className="stats-grid" initial={{ opacity: 0 }} animate={{ opacity: 1 }} key={activeTab}>
          <div className="stat-box wide" style={{ opacity: 0.5 }}>
            <span className="stat-label">No matches played yet</span>
            <span className="stat-value">-</span>
          </div>
        </motion.div>
      );
    }

    return (
      <motion.div 
        className="stats-grid"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        key={activeTab}
      >
        <div className="stat-box wide">
          <span className="stat-label">Matches Played</span>
          <span className="stat-value">{modeData.matches_played || 0}</span>
        </div>
        <div className="stat-box won">
          <span className="stat-label">Won</span>
          <span className="stat-value">{modeData.matches_won || 0}</span>
        </div>
        <div className="stat-box lost">
          <span className="stat-label">Lost</span>
          <span className="stat-value">{modeData.matches_lost || 0}</span>
        </div>

        {modeData.extra_stats && modeData.extra_stats.best_win_gap !== undefined && (
          <div className="stat-box">
            <span className="stat-label">Best Win Gap</span>
            <span className="stat-value">
              {modeData.extra_stats.best_win_gap > 0 ? `+${modeData.extra_stats.best_win_gap}` : '-'}
            </span>
          </div>
        )}

        {modeData.extra_stats && modeData.extra_stats.top_teammate !== undefined && (
          <div className="stat-box">
            <span className="stat-label">Top Teammate</span>
            <span className="stat-value">{modeData.extra_stats.top_teammate || '-'}</span>
          </div>
        )}
      </motion.div>
    );
  };

  const getAvailableModes = () => {
    return ['28', '56', 'donkey'];
  };

  return (
    <div className="dashboard-screen">
      <ParticleBackground />
      
      <div className="dashboard-header">
        <button className="btn btn-primary back-btn" onClick={onBack} style={{ width: 'auto' }}>
           ← Back to Lobby
        </button>
        <button className="btn btn-primary logout-btn" onClick={logout} style={{ width: 'auto' }}>
           Logout
        </button>
      </div>

      <motion.div 
        className="dashboard-content"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <div className="dashboard-card stats-card">
          <h2>Player Dossier</h2>
          <h3>{username}</h3>
          
          <div className="dash-tabs-container">
            <div className="dash-tabs">
              <button 
                className={`dash-tab ${activeTab === 'global' ? 'active' : ''}`}
                onClick={() => setActiveTab('global')}
              >
                Global
              </button>
              {getAvailableModes().map(mode => (
                <button 
                  key={mode}
                  className={`dash-tab ${activeTab === mode ? 'active' : ''}`}
                  onClick={() => setActiveTab(mode)}
                >
                  {mode.toUpperCase()}
                </button>
              ))}
            </div>
          </div>

          <div className="stats-container">
            {loadingStats ? (
              <div className="dash-loader"><CyberLoader /></div>
            ) : (
              <AnimatePresence mode="wait">
                {renderStats()}
              </AnimatePresence>
            )}
          </div>
        </div>
      </motion.div>
    </div>
  );
}
